import Reveal from "@/components/Reveal";
import Cta from "@/components/Cta";
import { Icon } from "@/components/Icon";
import { HERO, IMAGES, COMPANY } from "@/lib/content";

const Hero = () => {
  return (
    <section className="bg-white overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left */}
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
                {HERO.overline}
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h1 className="mt-4 font-heading text-[2.15rem] leading-[1.12] sm:text-5xl lg:text-[3.25rem] lg:leading-[1.1] font-bold tracking-[-0.02em] text-[#2A2E7A]">
                {HERO.headline}
              </h1>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-5 font-heading text-lg sm:text-xl font-medium text-[#34418C] leading-snug">
                {HERO.subheadline}
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <p className="mt-4 text-[16px] text-[#51607A] leading-[1.75] max-w-xl">
                {HERO.paragraph}
              </p>
            </Reveal>
            <Reveal delay={0.32}>
              <div className="mt-7 flex flex-col sm:flex-row gap-3.5">
                <Cta to="/contact" variant="primary" testId="hero-request-quote">
                  {HERO.primaryCta}
                </Cta>
                <Cta to="/services" variant="secondary" withArrow testId="hero-our-services">
                  {HERO.secondaryCta}
                </Cta>
              </div>
            </Reveal>
            <Reveal delay={0.4}>
              <div className="mt-8 flex items-center gap-2.5 text-[13px] font-medium text-[#6B7688]">
                <Icon name="ShieldCheck" className="h-4 w-4 text-[#4B5CAB]" />
                <span>Trusted by businesses across Aruba since {COMPANY.since}</span>
              </div>
            </Reveal>
          </div>

          {/* Right */}
          <Reveal delay={0.2} className="lg:col-span-5 relative">
            <div className="relative rounded-lg overflow-hidden shadow-[0_20px_50px_-20px_rgba(36,59,99,0.35)] border border-[#2A2E7A]/5">
              <img
                src={IMAGES.hero}
                alt="Best Bizz advisor shaking hands with clients during a meeting"
                className="w-full h-[340px] sm:h-[400px] lg:h-[440px] object-cover"
                loading="eager"
              />
            </div>
            <div
              className="hidden sm:flex absolute -bottom-5 -left-5 bg-white rounded-lg shadow-[0_16px_40px_-16px_rgba(36,59,99,0.4)] border border-[#2A2E7A]/5 px-5 py-4 items-center gap-3.5"
              data-testid="hero-badge-card"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-[6px] bg-[#F5F6FB]">
                <Icon name="BadgeDollarSign" className="h-5 w-5 text-[#2A2E7A]" />
              </span>
              <div>
                <p className="font-heading font-semibold text-[15px] text-[#2A2E7A] leading-none">Fixed Monthly Fees</p>
                <p className="mt-1.5 text-[13px] text-[#6B7688]">No surprises, ever</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;
